import React from 'react';
import { Link } from 'react-router';
import Download from './partials/downloads';
import Vendor from './partials/vendors';
import { Animated } from 'react-animated-css';
import { TabContent, TabPane, Nav, NavItem, NavLink, Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import classnames from 'classnames';
import moment from 'moment';
import DatePicker from 'react-datepicker';
import CustomDatePicker from '../common/CustomDatePicker2';
import Snapshot from './partials/snapshot';
import ImpactSnapshot from './partials/impact_snapshot';
import request from 'superagent';
import config from '../../config';
import _ from 'lodash';


class OrganizationImpactVideos extends React.Component {
    state = {
        activeTab: '2', //1: [2020, 2021, ....], 2: [JAN, FEB, MAR, MAY....], 3: [?]
        overlay: false,
        months: [
            `${moment().add(0, 'months').format('MMM YYYY')}`,
            `${moment().add(-1, 'months').format('MMM YYYY')}`,
            `${moment().add(-2, 'months').format('MMM YYYY')}`,
            `${moment().add(-3, 'months').format('MMM YYYY')}`,
            `${moment().add(-4, 'months').format('MMM YYYY')}`,
            `${moment().add(-5, 'months').format('MMM YYYY')}`,
        ],
        monthTo: moment().format('MMM YYYY'),
        yearTo: moment().format('YYYY'),
        yearFrom: moment().format('YYYY'),
        yearRange: [moment().format('YYYY'),
        moment().add(-1, 'years').format('YYYY'),
        moment().add(-2, 'years').format('YYYY'),
        moment().add(-3, 'years').format('YYYY')],
        from: moment().add(-7, 'days'),
        to: moment(),
        snapshot_mode: 3, //[1: today, 2: week, 3: month]
    }

    componentWillMount = () => {
        const { start, end } = this.state;
        request.post(`${config.apiEndpoint}/v1/impact/report`)
            .send({ start, end })
            .set('Authorization', `Bearer ${localStorage.getItem('sportslogic.authtoken')}`)
            .then(({ body: { videos } }) => {
                this.setState({ videos });
            });
    }

    applyFilters = () => {
        this.setState({ overlay: false })
    }

    handleChangeFrom = (date) => {
        const { to } = this.state;
        this.setState({
            from: moment(date),
            to: moment(date).isAfter(moment(to)) ? moment(date).add(1, 'day') : moment(to) // range validation
        });
    }

    handleChangeTo = (date) => {
        const { from } = this.state;
        this.setState({
            to: moment(date),
            from: moment(date).isBefore(moment(from)) ? moment(date).add(-1, 'day') : moment(from) // range validation
        });
    }

    render() {
        const { activeTab, yearRange, from, to, snapshot_mode, months, videos } = this.state;

        // Filter videos based on snapshot_mode
        let filteredVideos = videos || [];
        const today = moment().format('YYYY-MM-DD');

        if (snapshot_mode === 1) {
            filteredVideos = filteredVideos.filter(v =>
                moment(v.createDate).format('YYYY-MM-DD') === today
            );
        } else if (snapshot_mode === 2) {
            const weekAgo = moment().subtract(7, 'days').startOf('day');
            filteredVideos = filteredVideos.filter(v =>
                moment(v.createDate).isSameOrAfter(weekAgo)
            );
        } else if (snapshot_mode === 3) {
            const monthAgo = moment().subtract(30, 'days').startOf('day');
            filteredVideos = filteredVideos.filter(v =>
                moment(v.createDate).isSameOrAfter(monthAgo)
            );
        }


        return <section>
            {videos != null && <div className="w3-container" style={{ position: 'absolute', top: 0, bottom: 0, left: 0, right: 0, overflowY: 'auto' }}>

                <div className="w3-content mt-4 d-flex flex-row">
                    <h1>Snapshot</h1>
                    <button onClick={() => this.setState({ snapshot_mode: 1 })} className={`btn ml-auto btn-${snapshot_mode === 1 ? 'info' : 'link'}`}>Today</button>
                    <button onClick={() => this.setState({ snapshot_mode: 2 })} className={`btn btn-${snapshot_mode === 2 ? 'info' : 'link'}`}>7 Days</button>
                    <button onClick={() => this.setState({ snapshot_mode: 3 })} className={`btn btn-${snapshot_mode === 3 ? 'info' : 'link'}`}>30 Days</button>
                    <button onClick={() => this.setState({ snapshot_mode: 4 })} className={`btn btn-${snapshot_mode === 4 ? 'info' : 'link'}`}>All</button>
                </div>

                <ImpactSnapshot {...this.props} {...this.state} />

                <hr />

                {filteredVideos?.length > 0 && <div className="w3-content mt-4 d-flex flex-row mb-4">
                    <h1>Videos</h1>
                </div>}
                {filteredVideos?.length > 0 && filteredVideos.map(video => {

                    var status = 'Pending', bg = 'info';
                    if (video.impact_date) {
                        status = 'Ready'; bg = 'success';
                    }

                    return (<div className="w3-content sheet shadow card p-3" key={video.idVideo}>
                        <div className="d-flex flex-row">
                            <Link to={`/videos/team/${video.idTeam}/video/${video.idVideo}`} className="w-25">
                                <img src={video.thumbnail} className="w-100 align-self-center" alt="thumbnail" />
                            </Link>
                            <div className="w-75 pl-4 d-flex flex-column justify-content-center">
                                <span className="line1 font-8">{moment(video.createDate).format('MMM Do YYYY')}</span>
                                <Link to={`/roster/${video.idTeam}`} className="line1 font-16">{video.Team}</Link>
                                <span className="line1 font-12">Impact Id: {video.impact_id}</span>
                                <span className={`mt-2`}>Status: <i className={`bg-${bg} px-2 rounded`}>{status}</i></span>
                                <span className="font-8">External Id: {video.ExternalId}</span>
                            </div>
                        </div>
                    </div>)
                })}

                <div style={{ height: 100 }} />

            </div>}
            {this.state.overlay && <div onClick={() => this.setState({ overlay: false })} className={`overlay ${this.state.overlay ? 'show' : ''}`} />}
        </section>
    }
}

export default OrganizationImpactVideos;